import { Observable } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

export class ErrorParser {


    handleError( response: any ): any {
        const { status, statusText, url } = response; //Destructure HttpResponse object
        let name, message, value, kind ;

        response.name === 'HttpErrorResponse' && typeof response.error === 'object' ?
          { name, message, value, kind } = response.error :   // Destructure HttpErrorResponse object
          { name, message } = response ;                      // Destructure HttpResponse object

        let err = response;

        switch( status ) {
          case 200:
            err = new HttpResponse({ statusText: `Method Completed Succesfully: ${statusText}` })
            break;
          case 400:
            err = new HttpErrorResponse({ status: status, statusText: `${statusText}. ${name} - ${message}` })
            break;
          case 401:
            err = new HttpErrorResponse({ status: status, statusText: `${statusText}. Expired Token - Please Login Again` })
            break;
          case 403:
            err = new HttpErrorResponse({ status: status, statusText: `${statusText}: ${name} - Insufficient Permissions` })
            break;
          case 404:
            err = new HttpErrorResponse({ status: status, statusText: `${statusText}: ${name} - ${message}` })
            break;
          case 504:
            err = new HttpErrorResponse({ status: status, statusText: `${statusText}. Check If The Database Is Running` })
            break;
          default:
            err = new HttpResponse({ status: status, statusText: statusText })
            break;
        }


        return err;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/error-parser.ts